export default function(value) {
    this.el.disabled = Boolean(value);
}



/** WEBPACK FOOTER **
 ** ./src/directives/disabled.js
 **/